// DUCKS pattern
import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

import type { RootState } from 'store/store'

export interface UserListFilterState {
  isFilterOpen: boolean
  selectedStatusList: number[]
  selectedOrgList: number[]
  selectedFacsList: number[]
  selectedRolesList: number[]
  selectedLevelsList: number[]
  pageNumber?: number
  pageSize?: number
  sort?: string
}

export interface UserManagementState {
  userList: { data: []; totalCount: number; hasData: boolean }
  redirectTo: string
  selectedUserId: string
  refreshUserDets: boolean
  userListFilterState: UserListFilterState
}

const initialState: UserManagementState = {
  userList: { data: [], totalCount: 0, hasData: false },
  redirectTo: 'view-USER_LIST',
  selectedUserId: '',
  refreshUserDets: false,
  userListFilterState: {
    isFilterOpen: false,
    selectedStatusList: [],
    selectedOrgList: [],
    selectedFacsList: [],
    selectedRolesList: [],
    selectedLevelsList: [],
  },
}

// slice
export const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState,
  reducers: {
    setUserList: (state, action) => {
      state.userList = action.payload
    },
    setRedirectionTo: (state, action) => {
      state.redirectTo = action.payload
    },
    setSelectedUserId: (state, action) => {
      state.selectedUserId = action.payload
    },
    setRefreshUserDets: state => {
      state.refreshUserDets = !state.refreshUserDets
    },
    setUserListFilterState: (state, action) => {
      state.userListFilterState = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(PURGE, () => initialState)
  },
})

// Actions
export const userManagementActions = {
  setUserList: userManagementSlice.actions.setUserList,
  setRedirectionTo: userManagementSlice.actions.setRedirectionTo,
  setSelectedUserId: userManagementSlice.actions.setSelectedUserId,
  setRefreshUserDets: userManagementSlice.actions.setRefreshUserDets,
  setUserListFilterState: userManagementSlice.actions.setUserListFilterState,
}

// Selectors
export const listOfUsers = (state: RootState) => state.users.userList
export const redirectTo = (state: RootState) => state.users.redirectTo
export const getSelectedUserId = (state: RootState) => state.users.selectedUserId
export const getRefreshForUserDets = (state: RootState) => state.users.refreshUserDets
export const getUserListFilterState = (state: RootState) => state.users.userListFilterState

// Reducer
export default userManagementSlice.reducer
